"use strict";
exports.__esModule = true;
exports.distance = void 0;
var toLatLong_1 = require("./toLatLong");
var distance = function (pointFrom, pointTo) {
    var point1LatLong = (0, toLatLong_1.toLatLong)(pointFrom);
    var point2LatLong = (0, toLatLong_1.toLatLong)(pointTo);
    if (!point1LatLong || !point2LatLong)
        return null;
    var toRad = function (value) { return (value * Math.PI) / 180; };
    var long1 = point1LatLong.x;
    var lat1 = point1LatLong.y;
    var long2 = point2LatLong.x;
    var lat2 = point2LatLong.y;
    var earthRadius = 6371000;
    var distanceLat = toRad(lat2 - lat1);
    var distanceLong = toRad(long2 - long1);
    var lat1Rad = toRad(lat1);
    var lat2Rad = toRad(lat2);
    var a = Math.pow(Math.sin(distanceLat / 2), 2) + Math.pow(Math.sin(distanceLong / 2), 2) * Math.cos(lat1Rad) * Math.cos(lat2Rad);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadius * c;
};
exports.distance = distance;
//# sourceMappingURL=distance.js.map